import React from "react";
import { AccordionBody, AccordionHeader, AccordionItem } from "reactstrap";
import { useTranslation } from "react-i18next";
import InitialConditionSigma from "./MCSComponent/InitialConditionSigma";
import VehicleSigma from "./MCSComponent/VehicleSigma";
import AerodynamicSigma from "./MCSComponent/AerodynamicSigma";
import EngineSigma from "./MCSComponent/EngineSigma";
import RCSSigma from "./MCSComponent/RCSSigma";
import WindAndDisturbanceSigma from "./MCSComponent/WindAndDisturbanceSigma";
import TVCSigma from "./MCSComponent/TVCSigma";
import MRN01Sigma from "./MCSComponent/MRN01Sigma";
import GNSSSigma from "./MCSComponent/GNSSSigma";

const MCSSigma = ({ register, errors }) => {
  const { t } = useTranslation("gnc-simulator-6dof");
  return (
    <AccordionItem>
      <AccordionHeader targetId="6" className="mt-0 fw-bold">
        {t("new.MCS.title")}
      </AccordionHeader>
      <AccordionBody accordionId="6" className="mcs-body">
        <InitialConditionSigma register={register} errors={errors} />
        <VehicleSigma register={register} errors={errors} />
        <AerodynamicSigma register={register} errors={errors} />
        <EngineSigma register={register} errors={errors} />
        <TVCSigma register={register} errors={errors} />
        <RCSSigma register={register} errors={errors} />
        <WindAndDisturbanceSigma register={register} errors={errors} />
        <MRN01Sigma register={register} errors={errors} />
        <GNSSSigma register={register} errors={errors} />
      </AccordionBody>
    </AccordionItem>
  );
};

export default MCSSigma;
